import {
  AccessLevel,
  useAiSettingsAccessQuery,
} from 'lib-knowledge-management-common/graphql';

type UseCanEditAiSettingsReturn = {
  /** Unknown counts as no: a control that appears late beats one that fails. */
  canEdit: boolean;
  /** Settled, so a read-only notice will not flash for agents who can edit. */
  loaded: boolean;
};

/**
 * Whether the agent may change the AI settings, rather than only view them.
 * The backend turns the changes away otherwise; this just keeps them from
 * being offered.
 */
export function useCanEditAiSettings(): UseCanEditAiSettingsReturn {
  const { data } = useAiSettingsAccessQuery({ fetchPolicy: 'cache-first' });
  const access = data?.settings.userPermissions.languageSettings;

  return { canEdit: access === AccessLevel.Write, loaded: access != null };
}
